// test964
(964 && 0);
